import { withStyles } from '@material-ui/core';
import { SEARCH_FILTER_OPTIONS, SEARCH_TYPE } from '../constants';

const styles = (theme) => ({
  container: {
    fontWeight: 600,
    fontSize: '14px',
    color: theme.dispatchPanelLabelValueColor,
    paddingTop: '30%'
  }
});

const NotFound = ({ classes, searchBy, searchInputValue, driverData }) => {
  const inputLabel = SEARCH_FILTER_OPTIONS.find((option) => option.value === searchBy);
  const errorMessage =
    inputLabel.value === SEARCH_TYPE.DriverNumber
      ? `${inputLabel.label} #${searchInputValue} doesn't have a manifest for the date ${driverData}`
      : `${inputLabel.label} ${searchInputValue} is not part of a manifest`;
  return <div className={classes.container}> {errorMessage}</div>;
};

export default withStyles(styles)(NotFound);
